import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiGetMaterials = sinisterId => {
  const params = new URLSearchParams()
  params.set('sinister_id', sinisterId)

  return httpClient.get(`gag/materials${paramsToString(params)}`)
    .then(data => data)
}
